<template>
    <v-row v-if="checkboxLeftSide" class="app-form-checkbox-row" style="display: flex; align-items: flex-start">
        <v-checkbox
            :model-value="inputValue"
            @update:model-value="update"
            color="primary"
            :disabled="disabled"
            class="app-form-checkbox"
        >
	        <template v-slot:label>
		        <span style="color: #757575; white-space: normal; word-break: break-word;">{{ label }}</span>
	        </template>
        </v-checkbox>
       

<!--        <v-menu-->
<!--            open-on-hover-->
<!--            nudge-right="30"-->
<!--            nudge-top="10"-->
<!--            right-->
<!--            v-if="helperMessage"-->
<!--            transition="slide-x-transition"-->
<!--        >-->
<!--            <template v-slot:activator="{ on, attrs }">-->
<!--                <div class="helper-container ml-2" v-bind="attrs" v-on="on">-->
<!--                    <v-icon x-small color="white" >mdi-help</v-icon>-->
<!--                </div>-->
<!--            </template>-->

<!--            <app-card class="pa-2" hide-header>-->
<!--                {{ helperMessage }}-->
<!--            </app-card>-->
<!--        </v-menu>-->
        <HelperMessage 
            v-if="helperMessage" 
            :message="helperMessage"
        />



    </v-row>
    <v-row v-else>
        <v-col v-if="includeLabel" cols="3" style="display: flex; align-items: center; color: #757575">
            {{ label }}
        </v-col>
        <v-col :cols="includeLabel ? 9 : 12">
            <v-checkbox
                :model-value="inputValue"
                @update:model-value="update"
                color="text"
                :disabled="disabled"
                hide-details
            ></v-checkbox>
        </v-col>
    </v-row>
</template>

<script>
import HelperMessage from "@/components/HelperMessage";
export default {
    components: {HelperMessage},
    props: {
        // Support both Vue 2 (value) and Vue 3 (modelValue)
        value: {
            type: Boolean
        },
        modelValue: {
            type: Boolean
        },
        label: {
            required: false,
            type: String
        },
        checkboxLeftSide: {
            type: Boolean,
            default: false
        },
        helperMessage: {
            type: String
        },
        color: {
            default: 'primary'
        },
        disabled: {
            type: Boolean
        },
        includeLabel:{
            type: Boolean,
            default: true
        }
    },
    name: "AppFormCheckbox",
    emits: ['input', 'update:modelValue'],
    computed: {
        // Get the value from either modelValue (Vue 3) or value (Vue 2)
        inputValue() {
            return this.modelValue !== undefined ? this.modelValue : this.value
        }
    },
    methods: {
        update(newValue) {
            this.$emit('input', newValue)
            this.$emit('update:modelValue', newValue)
        }
    }
}
</script>

<style scoped>
/* Let checkbox rows grow to fit multi-line labels instead of clipping */
.app-form-checkbox-row {
    min-height: auto;
}

.app-form-checkbox :deep(.v-selection-control) {
    min-height: auto;
    align-items: flex-start;
}

.app-form-checkbox :deep(.v-label) {
    white-space: normal;
    overflow: visible;
    text-overflow: clip;
    opacity: 1;
    padding-top: 4px;
    line-height: 1.25;
}
</style>